import { Stack, Typography } from '@mui/material';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';

interface NoMeasurementFoundModalProps {
    onContinue: () => void;
}

export function NoMeasurementFoundModal({ onContinue }: NoMeasurementFoundModalProps) {
    return (
        <BaseDialog
            onClose={onContinue}
            title={`🚫 ${ts('no_measurement_found', 'No measurement found')}`}
            titleColor={theme.palette.error.main}
            actionLabel={ts('continue_button_label', 'Continue')}
            onAction={onContinue}
        >
            <Stack spacing={1.25} sx={{ textAlign: 'center', mx: 'auto', maxWidth: 450 }}>
                <Typography>
                    {ts('no_measurement_found_body', "We couldn't find a measurements on the floor plan.")}
                </Typography>
                <Typography>
                    {ts('no_measurement_found_set_scale', 'Please set the scale manually before proceeding.')}
                </Typography>
            </Stack>
        </BaseDialog>
    );
}